<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    
    <div class="breadcrumb">
        <div class="twelve">
          <div id="trail">
               <!--<ul> -->
                  <!--<li><a href="https://www.brighton.com/">Home</a></li> -->
                  <!--<li><a href="https://www.brighton.com/powerofpink/">Power Of Pink</a></li> -->
                  <!-- <li><a href="../brighton-cares">The Butterfly Ribbon</a></li> -->
                  <!-- <li>Submit Your Dedication</li> -->
               <!--</ul> -->
          </div>
        </div>
      </div>
    <div class="banner">
        <router-link to="/submit">
        <img :src="base_url+'pop-banner.jpg'" alt="">
        <button class="cta">POST A DEDICATION</button>  
      </router-link>
    </div>
    <span class="recognitionText">In recognition of Breast Cancer Awareness Month we would like to remember and honor members of our extended Brighton family.</span>
    <div class="search">
      <input type="text" v-on:keyup.enter = "searchSubmission" placeholder="Search names ..." v-model="searchTerm"><button @click="searchSubmission">GO</button>
      <select class="yearsDropDown" @change="changeYear(-1, $event)">
          <option value="2024">2024</option>
		  <option value="2023">2023</option>
          <option value="2022">2022</option>
          <option value="2021">2021</option>
          <option value="2020">2020</option>
          <option value="2019">2019</option>
          <option value="2018">2018</option>
          <option value="2017">2017</option>
          <option value="2016">2016</option>
      </select>
      <div class="years">
		<span @click="changeYear(2023)" :class="{active: year == 2024}" style="border-left:none;">2024</span>
        <span @click="changeYear(2023)" :class="{active: year == 2023}">2023</span>
        <span @click="changeYear(2022)" :class="{active: year == 2022}">2022</span>
        <span @click="changeYear(2021)" :class="{active: year == 2021}">2021</span> 
        <span @click="changeYear(2020)" :class="{active: year == 2020}" >2020</span> 
        <span @click="changeYear(2019)" :class="{active: year == 2019}" >2019</span> 
        <span @click="changeYear(2018)" :class="{active: year == 2018}">2018</span> 
        <span @click="changeYear(2017)" :class="{active: year == 2017}">2017</span> 
        <span @click="changeYear(2016)" :class="{active: year == 2016}">2016</span>
        <!-- <span @click="changeYear(2015)" :class="{active: year == 2015}">2015</span> | 
        <span @click="changeYear(2014)" :class="{active: year == 2014}">2014</span> | 
        <span @click="changeYear(2013)" :class="{active: year == 2013}">2013</span>   -->
      </div>
    </div>
    <div class="submissions">
      <div class="mask" :class="{active: loading}">
          <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
          <span class="sr-only">Loading...</span>
      </div>
      <div class="masonryWrapper" v-masonry origin-left="false"  transition-duration="0.3s" item-selector=".submission" horizontal-order="true" fit-width="true">
          <div v-masonry-tile  class="submission" v-for="(submission, index) in submissions">
            <span class="note" v-if="submission.note == 0">In Memory of ...</span>
            <span class="note" v-else>In Honor of ...</span>
            <span class="name">{{submission.firstName}} {{submission.lastName}}.</span>
            <img class="customizedImg" v-if="submission.uploadedImageFile != ''" :src="'https://app.brighton.com/power-of-pink/tmp/'+submission.uploadedImageFile" alt="">
            <img v-else-if="submission.note == 0" :src="base_url+'heart_icon.png'" alt="">
            <img v-else :src="base_url+'heart_icon2.png'" alt="">
            <!-- <img v-else src="heart_icon2.png" alt=""> -->
            <span class="pretext">{{submission.preText}}</span>
            <span class="yourName"><span v-if="submission.yourFirstName != ''">~{{submission.yourFirstName}} {{submission.yourLastName}}.</span><span v-else>&nbsp;</span></span>
            <!-- <span>{{submission.id}}</span> -->
          </div>
        </div>
        <button v-if="moreRecords" class="loadMoreBtn" @click="loadMore">Load More</button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

const axios = require('axios');
export default {
  name: 'home',
  components: {
    // HelloWorld
    
  },
  data () {
    return {
        loading: true,
        submissions: [],
        searchTerm: '',
        lastSubmissionID: -1,
        moreRecords: false,
        year: 2024,
        base_url: '',
        error: ''
    }
  },
  mounted () {
    this.getAllSubmissions((data)=>{
      this.loading = false
      this.base_url = process.env.BASE_URL
      // this.submissions = this.submissions.concat(data.submissions)
      this.submissions = data.submissions
      this.moreRecords = !data.last
      this.lastSubmissionID = this.submissions[this.submissions.length -1].id
    })
    // console.log(document.getElementById('shop_cart_link').href)
    // document.getElementById('shop_cart_link').href = 'https://www.brighton.com/cart'
  },
  computed: {
  },
  methods: {
    loadMore() {
      this.getAllSubmissions((data)=>{
        this.submissions = this.submissions.concat(data.submissions)
        this.moreRecords = !data.last
        this.lastSubmissionID = this.submissions.length > 0 ? this.submissions[this.submissions.length -1].id : -1
      })
    },
    changeYear(year, event) {
      // console.log(event.target.value)
      this.year = year != -1 ? year : event.target.value 
      this.searchTerm = ''
      // this.year = year
      this.lastSubmissionID = -1
      this.getAllSubmissions((data)=>{
        this.submissions = data.submissions
        this.moreRecords = !data.last
        this.lastSubmissionID = this.submissions.length > 0 ? this.submissions[this.submissions.length -1].id : -1
        // this.lastSubmissionID = this.submissions[this.submissions.length -1].id
      })
    },
    async searchSubmission () {
      if(this.searchTerm.trim() == '')
        return false
      this.getAllSubmissions((data)=>{
        this.submissions = data.submissions
        this.lastSubmissionID = this.submissions.length > 0 ? this.submissions[this.submissions.length -1].id : this.lastSubmissionID
        this.moreRecords = !data.last
      })
    },
    async getAllSubmissions (callBack) {
        var formData = new FormData();
        if(this.searchTerm.trim() != '') {
          formData.append('searchTerm', this.searchTerm)
          this.moreRecords = false
        }
        if(this.lastSubmissionID != -1)
          formData.append('lastSubmissionID', this.lastSubmissionID)

        formData.append('dev', process.env.NODE_ENV)
        formData.append('year', this.year)
        let url = `https://app.brighton.com/power-of-pink/api/`
        this.loading = true
        let returnedData = await axios( 
        {
            method: 'POST',
            url: url,
            responseType: 'json',
            data: formData,
            config: { headers: {'Content-Type':  'application/x-www-form-urlencoded'}},
            // onUploadProgress: function (e) {
            //     if (e.lengthComputable) {
            //         console.log("e.loaded: %o, e.total: %o, percent: %o", e.loaded, e.total, (e.loaded / e.total ) * 100);
            //     }
            // },
        })
        this.loading = false
        if(returnedData.data.success)
          callBack(returnedData.data)
        else
          this.error = returnedData.data
      }
  }
}
</script>
<style scoped lang="scss">

  .home{
    display:block;
    margin: 0 auto;

    #trail{
      clear: both;
      padding: 0 0 5px;
      margin: 0 auto 10px;
      border: none;
      overflow: hidden;
      ul{
        margin-left:0;padding-left:0;
        list-style:none;
        text-align:left;
        li{
          display: inline;
          padding: 0 4px 0 10px;
          margin: 0 4px 0 0;
              padding-left: 1.25em;
              background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA3NiA2Ny40Jz48ZGVmcz48c3R5bGU+LmF7ZmlsbDojOTE5MTkxO308L3N0eWxlPjwvZGVmcz48dGl0bGU+aGVhcnQ8L3RpdGxlPjxwYXRoIGNsYXNzPSdhJyBkPSdNNzYsMTkuOGEyOC40NSwyOC40NSwwLDAsMS0yLDkuN0M2OC4zLDQzLjcsMzcuOCw2Ny40LDM3LjgsNjcuNFM4LDQ0LjUsMi4xLDI5LjRBMzAuNDksMzAuNDksMCwwLDEsMCwxOS44YTE5Ljc4LDE5Ljc4LDAsMCwxLDM4LTcuNywxOS43OCwxOS43OCwwLDAsMSwzOCw3LjdaJy8+PC9zdmc+) 0 center no-repeat;;
              background-position: 0 .25em;
              background-size: 1em;
        }
      }
      a{
        color: #000;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: .08em;
        text-transform: uppercase;
      }
    }



    .banner{
      display:block;
      position:relative;
      background:url('https://app.brighton.com/power-of-pink/pop-banner.jpg?3') no-repeat;
      img{
        display:block;
        max-width:100%;
      }
      button.cta{
        position: absolute;
        bottom: 0;
        left: 50%;
        cursor: pointer;
        margin-left: -152px;
        background-color: black;
        border: none;
        color: white;
        font-weight: bold;
        padding: 14px 54px;
        letter-spacing: 1px;
        font-size: 16px;
      }
      button.cta:after{
        content: '';
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 4.5px 0 4.5px 7.8px;
        border-color: transparent transparent transparent #ffffff;
        vertical-align:middle;
        margin-left:10px;
        position:relative;
        display:inline-block;
      }
    }
    .recognitionText{
      display:block;
      /* font-weight:bold; */
      font-size:21px;
      padding:20px 4px;
      max-width:75%;
      margin: 0 auto;
    }
    .search{
      margin-top:20px;
      display:block;
      text-align:left;
      /* border-bottom:1px solid #ccc; */
      padding-bottom: 20px;
      margin-bottom:20px;
      position:relative;
      input{
        top: 5px;
        /* display: block; */
        /* position: absolute; */
        height: 32px;
        border: 1px solid #eb76b8;
        margin: 0;
        color: #666;
        height: 30px;
        padding: 0 10px;
        text-align: left;
        background: #fff;
        vertical-align: top;
        display: inline-block;
        /* width: 70%; */
        font-size:20px;
      }
      button{
        cursor: pointer;
        border: 0;
        margin: 0;
        outline: 0;
        color: #fff;
        padding: 0 10px;
        text-align: center;
        background: #eb76b8;
        vertical-align: top;
        display: inline-block;
        text-transform: uppercase;
        font: 16px/32px 'Lato', Arial, Helvetica, sans-serif;
      }
      .yearsDropDown{
        display: none;
        border: 1px solid #eb76b8;
        width: 100%;
        padding: 0 10px;
        height: 30px;
        font-size: 20px;
        margin-top: 10px;
      }
      .years{
        float:right;
        color: #ccc;
        padding: 0 10px;
        text-align: center;
        vertical-align: top;
        display: inline-block;
        text-decoration: none;
        /* border-left: 1px solid #ccc; */
        font: 24px/28px 'Lato', Arial, Helvetica, sans-serif;
        span{
          cursor:pointer;
          color: #ccc;
          padding: 0 10px;
          text-align: center;
          vertical-align: top;
          display: inline-block;
          text-decoration: none;
          border-left: 1px solid #ccc;
          font: 24px/28px 'Lato', Arial, Helvetica, sans-serif;
        }
        span.active{
          color:#eb76b8;
        }
      }
    }



    .submissions{
      width:auto;
      position:relative;
      
      .mask.active{
        display:block;
      }
      .mask{
        display:none;
        opacity:0.8;
        background-color:#fff;
        position:absolute;
        top:0;
        left:0;
        z-index: 2;
        width:100%;
        height:100%;
        i.fa{
          margin-top:50%;
          color:#eb76b8;
        }
      }
      .loadMoreBtn{
        display: block;
        color: #fff;
        cursor: pointer;
        text-align: center;
        letter-spacing: 1px;
        text-transform: uppercase;
        border-top: 1px solid #ccc;
        font: bold 12px/60px 'Muli', Arial, Helvetica, sans-serif;
        background-color: #c82c6f;
        margin: 10px 0 20px 0;
        width:100%;
      }
      /* .masonryWrapper.active{
        filter: blur(5px);
        
      } */
      .masonryWrapper{
        /* filter: blur(5px); */
        text-align:center;
        margin:0 auto;
        .submission{
          display:block;
          border-top:1px solid #ccc;
          padding:20px 10px;
          img{
            display:block;
            box-sizing:border-box;
            /* padding: 0 10px; */
            width:80%;
            margin:0 auto;
          }
          img.customizedImg{
            background-color:#dc568f;

          }
          span.pretext{
            color: #000000;
            font-weight: bold;
          }
          span.note{
            padding:0;
          }
          span.name{
            display: block !important;
            position: relative;
            margin: 0 auto;
            font: italic 22px/22px "Times New Roman", Times, serif;
            padding: 0;
            color: #000;
          }
          span.pretext{
            color: #000;
            font-weight: bold;
          }
          span{
            display:block;
            padding: 20px 5px 5px;
            font: italic 14px/18px "Times New Roman", Times, serif;
          }
          span.yourName{
            padding:0;
            span{
              padding:0;
              display:inline-block;
            }
          }
        }
      }
    }

  }
@media(max-width:768px) {
  .home .search {
    text-align:center;
    .years{
      float:none;
      display:block;
      margin-top:20px;
    }
  }
  .home .banner{
    margin-bottom:7%;
    background-size: 124%;
    button.cta{
      display:block;
      bottom:-37px;
    }
    img{
      opacity:0;
    }
  }
  
}

@media(max-width:500px) { 
  .home .banner{
    background-position-x: 52%;
    background-size: 168%;
    background-position-y: 37%;
  }
}
@media(max-width:415px) { 
  .home .recognitionText{
    padding:10px;
    width:auto;
    max-width:100%;
    padding-bottom:0;
    font-size:19px;
  }
  .home .banner{
    margin-bottom:54px; 
    button.cta{
      position:relative;
      display: block;
      top: 55px;
      width: 100%;
      left: 0;
      margin: 0 auto;
      font-size: 14px;
      padding: 18px 0;
      bottom:unset;
    } 
  }
}
@media(max-width:375px) {
  .home .search {
    /* button{
      width:100%;
      margin-top:10px;
    } */
    input {
      width:calc(100% - 67px);
      /* box-sizing:border-box; */
    }
    .yearsDropDown{
      display:block;
    }
    .years {
      display:none;
      text-align:left;
      span{
        display:block;
        border:none;
      }
    }

  }
}
</style>